module.exports = __webpack_public_path__ + "img/der.b2e6f454.png";